import { InfoText } from "plos/src/components/tooltips/InfoText";
import { useTranslation } from "react-i18next";
import { FDRCellStyles, TeamnameStyles } from "./fdrCell.css";
import { FDRCellProps } from "./types";

const FDRCell = ({
  difficulty = 1,
  teamName,
  isHome,
  isMultiple = false,
}: FDRCellProps) => {
  const { t } = useTranslation("fixturesAndFDR");

  if (!teamName) {
    return (
      <div data-testid="fdr-cell-empty" className={FDRCellStyles[3]}>
        -
      </div>
    );
  }

  const difficultyLabel = t(
    "fdrCell.difficultyLabel",
    "Fixture Difficulty Rating: {{difficulty}}",
    { difficulty },
  );

  return (
    <div
      className={FDRCellStyles[difficulty]}
      data-testid="fdr-cell-full"
      data-multiple={isMultiple}
    >
      <InfoText
        label={`${teamName}, ${difficultyLabel}`}
        tooltipText={difficultyLabel}
      >
        <span className={TeamnameStyles}>{teamName}</span>
      </InfoText>
      {isHome !== undefined && (
        <span>
          ({isHome ? t("fdrCell.home", "H") : t("fdrCell.away", "A")})
        </span>
      )}
    </div>
  );
};

export default FDRCell;
